export default "__VITE_ASSET__3a135ac6__"